import {change_loading, set_data_users} from "../reducers/main_reducer";
import axios from "axios";

export const ThunkGetDataUsers = (dateStart, dateEnd, id_user = '') => {
    return async (dispatch) => {
        dispatch(change_loading(true))

        const users_data = await axios({
            url: ' https://b22.oksyst.ru/mk_calendar.php',
            method: 'post',
            data: {
                id_user: id_user,
                date_start:`${dateStart} 00.00.00`,
                date_end: `${dateEnd} 23:59:59`
            }
        })

        console.log(users_data.data);

        dispatch(set_data_users(users_data.data))

        dispatch(change_loading(false))
    }
}